import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "flex flex-col md:flex-row px-6 lg:px-[7.5rem] py-6 border-b border-gray-200 cursor-pointer" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("img", {
  src: "/images/SableLogo.png",
  class: "w-[1.5rem] h-[1.5rem]"
}, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "text-lg font-bold ml-4" }, "Cookie Eye", -1)
const _hoisted_4 = [
  _hoisted_2,
  _hoisted_3
]
const _hoisted_5 = { class: "flex items-center space-x-8 md:ml-8 mt-6 md:mt-0" }
const _hoisted_6 = { class: "text-base font-medium leading-6 text-[#475467]" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: "flex",
      onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.refreshPage && _ctx.refreshPage(...args)))
    }, _hoisted_4),
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("div", {
        class: "text-base font-medium leading-6 text-[#475467]",
        onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.refreshPage && _ctx.refreshPage(...args)))
      }, " หน้าแรก "),
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("div", {
          onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.openLawman && _ctx.openLawman(...args)))
        }, "เกี่ยวกับ PDPA")
      ])
    ])
  ]))
}